var type = "return";
$(document).ready(function () {
  if (searchParams.get("type") != null) {
    type = searchParams.get("type");
    $(
      `.policyPage .content .policyPageContainer .policyTab .tabItem[data-type=${type}]`
    ).click();
  }
});
$(".policyPage .content .policyPageContainer .policyTab .tabItem").on(
  "click",
  function () {
    const current = $(this).attr("data-type");
    $(
      ".policyPage .content .policyPageContainer .policyTab .tabItem"
    ).removeClass("active");
    $(this).addClass("active");
    $(
      ".policyPage .content .policyPageContainer .policyPostList .policyPost"
    ).each(function (i, item) {
      if ($(item).attr("data-type") == current) {
        searchParams.set("type", current);
        window.history.replaceState(
          {},
          "",
          `${window.location.pathname}?${searchParams.toString()}`
        );
        window.scroll(0, 0);
        $(item).addClass("active");
      } else {
        $(item).removeClass("active");
      }
    });
  }
);
